export default __webpack_public_path__ + "static/media/ashtma.5bba82b1.svg";